import React from "react";
import "./Why.css";
import WhyProblems from "./WhyProblems";

function Why() {
  return (
    <section className="why-section" id="why">
      <div className="why__badge">The Problem</div>
      <h2 className="why__headline">
        Why <em className="why__highlight">you're</em> probably getting<br />Porsche pricing wrong
      </h2>
      <WhyProblems />
    </section>
  );
}

export default Why;
